import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

export function Stars({
  value,
  count,
  className,
}: {
  value: number;
  count?: number;
  className?: string;
}) {
  const full = Math.round(value);
  return (
    <span
      role="img"
      aria-label={`${value.toFixed(1)} out of 5`}
      className={cn("inline-flex items-center gap-1", className)}
    >
      <span className="flex">
        {[1, 2, 3, 4, 5].map((n) => (
          <Star
            key={n}
            className={cn(
              "size-3.5",
              n <= full ? "fill-[#E8A93C] text-[#E8A93C]" : "fill-none text-border-2",
            )}
          />
        ))}
      </span>
      <span className="text-xs font-medium text-fg-2">
        {value.toFixed(1)}
        {typeof count === "number" ? ` (${count})` : ""}
      </span>
    </span>
  );
}
